import { useState } from 'react';

export default function FlooringFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does flooring installation cost in El Paso?',
      answer: 'Flooring costs in El Paso vary by material: carpet ($2-$8/sq ft installed), luxury vinyl plank ($3-$10/sq ft), laminate ($3-$8/sq ft), tile ($5-$15/sq ft), and hardwood ($6-$20/sq ft). For a 1,000 sq ft area, expect to pay $2,000-$20,000 depending on material choice, subfloor condition, and installation complexity.'
    },
    {
      question: 'What is the best flooring for El Paso\'s climate?',
      answer: 'Tile and luxury vinyl plank (LVP) are ideal for El Paso\'s hot, dry climate. Tile stays cool and handles temperature fluctuations well, while LVP is waterproof and won\'t expand or contract with humidity changes. Hardwood also works well in our low-humidity environment but requires proper acclimation before installation.'
    },
    {
      question: 'How long does flooring installation take?',
      answer: 'Installation time depends on the flooring type and room size. Carpet installation takes 1-2 days, LVP and laminate take 2-3 days, tile takes 3-5 days (including grout curing), and hardwood takes 3-5 days plus additional time for finishing. Larger projects or complex layouts may require more time.'
    },
    {
      question: 'Do I need to remove old flooring before installation?',
      answer: 'It depends on the existing and new flooring types. Carpet usually needs removal, while some flooring can be installed over existing materials if the subfloor is level and stable. Your contractor will assess the situation during the estimate. Removal typically adds $1-$3 per square foot to the project cost.'
    },
    {
      question: 'How long before I can walk on new flooring?',
      answer: 'Carpet and LVP can be walked on immediately after installation. Laminate flooring needs 24 hours. Tile requires 24-48 hours for adhesive to set and 72 hours before grouting. Hardwood needs 24 hours for adhesive and 3-7 days after finishing. Always follow your contractor\'s specific recommendations.'
    },
    {
      question: 'What flooring is best for resale value in El Paso?',
      answer: 'Hardwood flooring offers the highest return on investment, adding 3-5% to home value. Luxury vinyl plank is increasingly popular with buyers for its durability and appearance. Tile in kitchens and bathrooms is expected by El Paso buyers. Avoid overly trendy colors or patterns that may not appeal to future buyers.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about flooring installation in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-${
                      openIndex === index ? 'up' : 'down'
                    }-s-line text-white text-xl`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
